import { useReducer } from 'react'

export const useStateReducer = <T>(initialState: T) => {
  const reducer = (state: T, next: Partial<T>): T => ({ ...state, ...next })

  const [state, updateState] = useReducer(reducer, initialState)

  return [state, updateState] as const
}
